import { GetApp } from '@mui/icons-material';
import { Divider, Skeleton } from '@mui/material';
import ButtonComponent from 'components/design-system/Button/Button';
import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import { SidebarLayout } from 'layouts/Sidebar/SidebarLayout';

export const DescargarReportesSkeleton = () => {
  return (
    <SidebarLayout>
      <div className="flex items-center mb-4">
        <div>
          <Heading type="h2" className="mb-0">
            Reportes
          </Heading>
          <Text className="mb-4">
            Genera reportes según los filtros que tu definas basados en los
            datos ingresados en la plataforma.
          </Text>
        </div>
      </div>

      <div className="bg-white rounded shadow-md mb-5">
        <div className="grid grid-cols-12 p-5 gap-5">
          <div className="col-span-12">
            <div className="grid grid-cols-12 gap-5">
              <div className="col-span-12">
                <Text>Selecciona el tipo de reporte a generar:</Text>
              </div>
              <div className="col-span-12 md:col-span-6 pr-10">
                <Skeleton
                  variant="rounded"
                  className="w-full h-6 rounded relative z-0 min-w-full flex justify-center items-center mb-2"
                />
                <Skeleton
                  variant="rounded"
                  className="w-full h-14 rounded relative z-0 min-w-full flex justify-center items-center"
                />
              </div>

              <div className="col-span-12 md:col-span-6 pr-10">
                <Skeleton
                  variant="rounded"
                  className="w-full h-6 rounded relative z-0 min-w-full flex justify-center items-center mb-2"
                />
                <Skeleton
                  variant="rounded"
                  className="w-full h-14 rounded relative z-0 min-w-full flex justify-center items-center"
                />
              </div>
            </div>
          </div>
          <div className="col-span-12 my-4">
            <Divider />
          </div>

          <div className="col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-3">
            <Skeleton
              variant="rounded"
              className="w-full h-10 rounded relative z-0 min-w-full flex justify-center items-center mb-2"
            />
          </div>

          <div className="col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-3">
            <Skeleton
              variant="rounded"
              className="w-full h-10 rounded relative z-0 min-w-full flex justify-center items-center mb-2"
            />
          </div>

          <div className="col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-3">
            <Skeleton
              variant="rounded"
              className="w-full h-10 rounded relative z-0 min-w-full flex justify-center items-center mb-2"
            />
          </div>

          <div className="col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-3">
            <Skeleton
              variant="rounded"
              className="w-full h-10 rounded relative z-0 min-w-full flex justify-center items-center mb-2"
            />
          </div>

          <div className="col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-3">
            <Skeleton
              variant="rounded"
              className="w-full h-10 rounded relative z-0 min-w-full flex justify-center items-center mb-2"
            />
          </div>

          <div className="col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-3">
            <Skeleton
              variant="rounded"
              className="w-full h-10 rounded relative z-0 min-w-full flex justify-center items-center mb-2"
            />
          </div>

          <div className="col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-3">
            <Skeleton
              variant="rounded"
              className="w-full h-10 rounded relative z-0 min-w-full flex justify-center items-center mb-2"
            />
          </div>
          <div className="col-span-12">
            <Divider />
          </div>
          <div className="col-span-12">
            <ButtonComponent
              buttonType="submit"
              className="h-auto"
              disabled={true}
              isLoading={true}
            >
              Descargar
              <GetApp className="ml-1" />
            </ButtonComponent>
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
};
